import { constants } from '../constants/constants';
import {
	IRetrieveOnBoardPaymentAccount,
  IRetrieveOnboardPaymentResponse
} from '../models/action-payloads/retrieve-onboard-payment-payload';

import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers';
import { Injectable } from '@angular/core';
import {ObjectManagerUtils} from '../utils/object-manager.utils';

// Models
import {
  PaymentType,
  IGetGuestSecurityPhoto,
  ISavePassengerSurveyPayload,
} from '../models';

// Services
import { GuestService } from '../modules/core/services/guest.service';

@Injectable()
export class OlciUtils {
  private readonly FIRST_TIME_CRUISE = '1'; // '1' = yes, '0' = No

	constructor(
    private readonly store: Store<fromRoot.AppState>,
    private readonly objectManagerUtils: ObjectManagerUtils,
    private readonly guestService: GuestService
  ) {}

  mapExpensesInfoToNewStoreFormat(expensesInfo: IRetrieveOnboardPaymentResponse) {
    let result: any = [];
    const onboardPaymentAccounts = expensesInfo?.payload?.onboardPaymentAccounts || [];

    for (const oExpenseData of onboardPaymentAccounts) {
      const accountGrantees = _.get(oExpenseData, 'account.grantees', []);
      const accountGrantorId = _.get(oExpenseData, 'account.grantor.guestReservationId.guestId', null);

      const granteeLoopResults = this.createGranteeLoopResults(accountGrantees, accountGrantorId, oExpenseData);
      result = [...result, ...granteeLoopResults];
    }
    return result;
  }

  createGranteeLoopResults(accountGrantees: any[], accountGrantorId: any, oExpenseData: IRetrieveOnBoardPaymentAccount) {
    const result: any = [];
    for (const grantee of accountGrantees) {
      const granteeId = _.get(grantee, 'guestReservationId.guestId', null);
      if (granteeId && accountGrantorId) {
        const isAccountGrantor = granteeId === accountGrantorId;
        const paymentType = this.mapPaymentType(oExpenseData.account.paymentTypeCode);
        const guestPaymentAccount = {
          guestId: granteeId,
          expensesAccount: {
            accountId: oExpenseData.account.accountId.toString(),
            paymentType: paymentType,
            creditCard: this.objectManagerUtils.ternaryValidation(
              paymentType === PaymentType.CreditCard,
              this.createNewCreditCard(oExpenseData),
              null
            ),
            consentContent: null,
            bookingAccessToken: null,
            granteeList: this.objectManagerUtils.ternaryValidation(
              isAccountGrantor,
              accountGrantees.map((accountGrantee: any) => ({ guestId: accountGrantee.guestReservationId.guestId })),
              []
            )
          }
        };
        result.push(guestPaymentAccount);
      }
    }
    return result;
  }

	createNewCreditCard(oExpenseData: IRetrieveOnBoardPaymentAccount) {
		return {
			holderName: oExpenseData.account.card.holderName,
			partialNumber: oExpenseData.account.card.partialNumber.toString(),
			cardType: oExpenseData.account.paymentTypeCode,
			expirationMonth: this.objectManagerUtils.ternaryValidation(
        oExpenseData.account.card.expirationMonth.toString().length > 1,
        oExpenseData.account.card.expirationMonth.toString(),
        `0${oExpenseData.account.card.expirationMonth.toString()}`
      ),
			expirationYear: this.objectManagerUtils.ternaryValidation(
        oExpenseData.account.card.expirationYear.toString().length === 4,
        Number(oExpenseData.account.card.expirationYear.toString().substring(2, 4)),
        oExpenseData.account.card.expirationYear
      ),
			nonUSCardFlag: null,
			conversionAffirmationFlag: oExpenseData.account.card.currencyConversion.conversionAffirmation,
			tokenText: this.objectManagerUtils.ternaryValidation(
        oExpenseData.account.card.tokenText,
        oExpenseData.account.card.tokenText,
        ''
      )
		};
	}

	mapPaymentType(paymentType: string) {
		switch (paymentType) {
			case constants.PAYMENT_TYPE.CASH:
				return PaymentType.Cash;
			case constants.PAYMENT_TYPE.NO_CHARGING_PRIVILEGES:
				return PaymentType.None;
			default:
				return PaymentType.CreditCard;
		}
	}

  retrieveRequestPayloadPhotos(payload: any): IGetGuestSecurityPhoto {
    return {
      reservationIds: payload.reservationIds ?? [],
      shipCode: this.guestService?.guestProfileBookingData?.shipCode,
      sailDate: this.guestService?.guestProfileBookingData?.sailDate,
      };
  }

  retrieveRequestPayloadSurvey(payload: any): ISavePassengerSurveyPayload {
    return {
      guestReservationId: {
        bookingId: payload?.guestSurvey?.bookingId,
        guestId: payload?.guestId,
      },
      firstTimeCruise: payload?.passengerSurvey?.firstTimeCruise === this.FIRST_TIME_CRUISE,
    };
  }
}
